(function () {
  'use strict';

  angular.module('app').component('providerTypeList', providerTypeList());

  function providerTypeList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        loadingItems: '<',
        onShowItem: '&',
        defaultLanguage: '<',
      },
      controller: ProviderTypeListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/provider-types/provider-type-list/provider-type-list.component.html',
    };
  }

  ProviderTypeListCtrl.$inject = ['UtilService', 'AbilityService', 'ProviderTypeService'];

  function ProviderTypeListCtrl(UtilService, AbilityService, ProviderTypeService) {
    var vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_providertype_accountadmin'),
      canUpdate: AbilityService.can('update_providertype_accountadmin'),
      canDestroy: AbilityService.can('destroy_providertype_accountadmin'),
    };

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = ProviderTypeService.getFilterCriteria();

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    vm.deleteItem = deleteItem;
    vm.changeItemStatus = changeItemStatus;
    vm.changeItemDefault = changeItemDefault;

    vm.$onInit = function () {
      checkDefaultProviderType(vm.items);
    };

    function fetchResult() {
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      ProviderTypeService.getProviderTypes(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        checkDefaultProviderType(vm.items);

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.filterCriteria = ProviderTypeService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item, mode) {
      if (!vm.permissions.canShow) {
        return;
      }

      vm.onShowItem({ item: item, mode: mode });
    }

    function deleteItem(item) {
      ProviderTypeService.deleteProviderType(item, fetchResult);
    }

    function changeItemStatus(item) {
      ProviderTypeService.changeProviderTypeStatus(item);
    }

    function changeItemDefault(item) {
      ProviderTypeService.changeProviderTypeDefault(item, fetchResult);
    }

    function checkDefaultProviderType(items) {
      var found = false;

      for (var i = 0; i < items.length; i++) {
        var providerType = items[i];
        if (providerType.predefined) {
          found = true;
          break;
        }
      }

      vm.noDefaultProviderType = !found;
    }
  }
})();
